<template>
  <v-card class="px-2 rounded-lg" elevation="0">
    <v-card-subtitle class="font-weight-bold" v-if="!untitle">{{
      title
    }}</v-card-subtitle>
    <v-divider v-if="!untitle"></v-divider>
    <v-card-text class="px-4">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "CardModule",
  props: {
    title: {
      type: String,
      default: "",
    },
    untitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
